import { Component, OnInit } from '@angular/core';
import { LocalService } from '../_services/local.service';
import { AuthService } from '../core/auth/auth.service';
import { getAdminMenuForRoles } from '../core/auth/admin-role-menu';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  constructor(private _localService: LocalService, private _authService: AuthService) {}

  ngOnInit(): void {
    this.filterMenuByRole();
  }

  filterMenuByRole(): void {
    this.model = getAdminMenuForRoles(this._authService.getLoginUser()?.UserRoles);
    this._localService.setValue('userPermissions', this.model);
  }
}
